import { Background } from 'components/Background/Background';
import { Button } from 'components/Button/Button';
import { SvgIcon } from 'components/SvgIcon/SvgIcon';
import styled from 'styled-components';

export const StyledChapterEntry = styled.div<{ $ignoreAnimation: boolean }>`
  display: block;

  position: relative;
  z-index: 2;

  color: ${props => props.theme.colors.white};

  min-height: 100%;

  @keyframes entry {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  } 

  > * {
    position: relative;
    ${ (props) => props.$ignoreAnimation 
      ? `opacity: 1;` 
      : `opacity: 0; animation: entry 600ms 200ms forwards;`
    }
  }
`;

export const StyledChapterEntryBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: black;
  z-index: 0;
`;
export const StyledChapterEntryIcon = styled(SvgIcon)`
  width: 66%;
  margin: 29px auto;
  animation: none !important;
`;
export const StyledChapterEntrySupTitle = styled.div`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 16px;
`;
export const StyledChapterEntryTitle = styled.div`
  font-size: 42px;
  line-height: 48px;
`;
export const StyledChapterEntryText = styled.div`
  font-size: 17px;
  line-height: 21px;
  padding-right: 45px;

  p {
    margin: inherit 10px;
  }

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
      flex: 1;
    }

    img {
      max-height: 100px;
    }

    > * + * {
      margin-left: 20px;
    }
  }
`;
export const StyledEntryTextContainer = styled.div`
  padding-left: 27px;
  padding-right: 35px; 
`;
export const StyledChapterEntryButtonContainer = styled.div`
  margin-top: 48px;
  padding-left: 27px;
  padding-right: 35px; 
  padding-bottom: 41px;
`;
export const StyledChapterEntryButton = styled(Button)`
  width: 100%;
`;